module.exports = __webpack_public_path__ + "img/pcad-define-system.6d68dc7f.png";